/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import ServicesComponent from './services.component';

import ServicesActivations from './activations/activations';
import ServicesDetails from './details/details';

import OrderAndPayDetails from './orderAndPay/orderAndPay';
import MessageOutboundDetails from './messageOutbound/messageOutbound';
import OrderAndPickDetails from './orderAndPick/orderAndPick';
import OfficeDeliveryDetails from './officeDelivery/officeDelivery';
import OrderAndDeliveryDetails from './orderAndDelivery/orderAndDelivery';
import BillAtTableDetails from './billAtTable/billAtTable';
import OrderAtTable from './orderAtTable/orderAtTable';
import PayWithAlipay from './payWithAlipay/payWithAlipay';
import ProjectWithAlipay from './projectWithAlipay/projectWithAlipay';
import MobilePayWithAlipay from './mobilePayWithAlipay/mobilePayWithAlipay';
import OnlinePayWithAlipay from './onlinePayWithAlipay/onlinePayWithAlipay';
import PayWithPaypal from './payWithPaypal/payWithPaypal';

const servicesModule = angular.module('tinaba.components.services', [
    uiRouter,
    ServicesDetails.name,
    ServicesActivations.name,
    OrderAndPayDetails.name,
    MessageOutboundDetails.name,
    OrderAndPickDetails.name,
    OrderAndDeliveryDetails.name,
    OfficeDeliveryDetails.name,
    BillAtTableDetails.name,
    OrderAtTable.name,
    PayWithAlipay.name,
    ProjectWithAlipay.name,
    MobilePayWithAlipay.name,
    OnlinePayWithAlipay.name,
    PayWithPaypal.name
    
])

    .config(($stateProvider) => {
        'ngInject';
        $stateProvider.state('services', {
            url: '/services',
            template: '<services></services>',
            redirect: 'services.activations',
            data: {
                services: true // show services in sidenav
            }
        });
    })

    .component('services', ServicesComponent);

export default servicesModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/services.js
 **/